import request from '@/request/request'


// 新增设备
export function uploadFile(data) {
    let form = new FormData();
    form.append("file", data);
    return request({
        // url: '/file-server/upload',
        url: 'common-server/uploadFiles',
        method: 'post',
        data: form,
        headers: {
            // ignoreValidate: true,
            "Content-Type":"multipart/form-data"
        }
    })
}

